/* Kiwi "View all" for long information tables. One device for the whole site.
   Any table inside the wrappers listed below with more than LIMIT body rows shows the first
   SHOW rows and a "View all N" link under it, the theme's underlined text link. Clicking
   shows the rest and the link becomes "Show fewer". Nothing is removed from the DOM, so
   find-in-page, print and screen readers still get every row (print always shows all).
   Grouped tables (the standards matrix, with band rows) count band rows as rows, so a band is
   never split from its first style. Wrappers opt out with data-kiwi-more="off"; a wrapper can
   set its own count with data-kiwi-more="12".
   2026-09-21 (owner): the product page Inventory table (blocks/ai_gen_block_dd15706.liquid,
   wrapper .kiwi-pdp-inv) folds the same way at every width.
   2026-09-29: that table now sits in its own scroller, .kiwi-pdp-inv__scroll, so the link goes
   under the scroller rather than inside it.
   AV 2026-09-24: the Shop by Trade "Where the risk actually is" table (.kiwi-td, 16 rows) and the
   collection compare grids (.kcg, 16 to 50 rows) now fold too (Brand page, Rulings 2026-09-10:
   an information table with more than 10 rows shows 8 and "View all N rows"). Neither has band
   rows. The compare grid is re-fetched and swapped in when the shopper re-sorts, so a new .kcg
   is folded the moment it arrives. */
(function () {
  'use strict';
  /* 2026-09-29 (e4): .krp__fold, the Rep Playbook's per-style commission breakdown (96 rows). */
  var SEL = '.kiwi-jt table, .khm table, .kiwi-st table, .ksm table, .kiwi-ct table, .kiwi-pdp-inv table, .kiwi-td table, .kcg table, .krp__fold table';
  var LIMIT = 10, SHOW = 8;
  function setup(tbl) {
    if (tbl.dataset.kiwiMoreDone) return;
    var wrap = tbl.closest('[data-kiwi-more]');
    var opt = wrap ? wrap.getAttribute('data-kiwi-more') : '';
    if (opt === 'off') return;
    var show = parseInt(opt, 10) || SHOW;
    var rows = [].slice.call(tbl.tBodies.length ? [].concat.apply([], [].map.call(tbl.tBodies, function (b) { return [].slice.call(b.rows); })) : []);
    if (rows.length <= Math.max(LIMIT, show + 2)) return;
    // never cut just after a band row
    while (show < rows.length && rows[show - 1].querySelector('th[colspan], td[colspan]')) show += 1;
    tbl.dataset.kiwiMoreDone = '1';
    var hidden = rows.slice(show);
    var open = false;
    function apply() { hidden.forEach(function (r) { r.classList.toggle('kiwi-more__hidden', !open); }); }
    // the theme's underlined text link, not a button (Gaurav 2026-09-10)
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'text-link-bare kiwi-more__btn';
    var box = document.createElement('div');
    box.className = 'kiwi-more__wrap';
    box.appendChild(btn);
    function label() { btn.textContent = open ? 'Show fewer' : 'View all ' + rows.length + ' rows'; }
    btn.addEventListener('click', function () {
      open = !open; apply(); label();
      if (!open) { var top = tbl.getBoundingClientRect().top + window.scrollY - 120; if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' }); }
    });
    apply(); label();
    var host = tbl.closest('.ksm__scroll, .kiwi-ct__scroll, .khm__scroll, .kiwi-jt__scroll, .kiwi-td__scroll, .kcg__scroll, .kiwi-pdp-inv__scroll') || tbl;
    host.insertAdjacentElement('afterend', box);
  }
  function run() { [].forEach.call(document.querySelectorAll(SEL), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  // AV 2026-09-24: a re-sorted compare grid arrives as a new .kcg; fold it as well.
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('kcg')) { run(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Kiwi: Shopify Forms app block, the rules its CSS custom properties cannot carry.
   Everything else is set on the <shopify-forms-embed> host in assets/kiwi-forms-embed.css,
   which also records what this is matching and why. The app draws into an OPEN shadow root,
   so a stylesheet can be appended to it, but its class names are hashed CSS modules and
   Shopify re-hashes the suffix on every app build. The selectors below are therefore semantic
   (h2, legend, input) or a class-name PREFIX match, never a full hashed class, and they carry
   !important because the app's own rules arrive as adopted stylesheets.

   What is here and why each one cannot be a custom property:
   - uppercase and .11em on the form heading and the submit button (no property exists)
   - flush-left field text and floating label, so an underline field reads like the Globo one
     it replaces (--form-field-padding sets the vertical rhythm AND the horizontal inset from
     one value, and the underline look needs them different). The submit button keeps its own
     padding from --button-padding and is deliberately not included in that rule.
   - the address block's legend, styled as the theme's in-body subheader (heading-size-5,
     which is --font-5 x --FONT-ADJUST-HEADING, 17.5 / 16 / 15.5px, inherited from :root)
   - the phone-width grid override, see the note inside CSS below.
   - the app's "View our privacy policy and terms of service." line under the submit button.
     It carries no links on any Kiwi form, so it is 10px of grey text that only adds 26px
     under the button and throws the section's bottom spacing off (Gaurav 2026-09-14).

   Rides in this file so layout/theme.liquid does not need another script tag. Polls at most
   forty times (ten seconds) and stops as soon as every embed on the page is painted. */
(function () {
  'use strict';
  var CSS =
    'h2{text-transform:uppercase !important;letter-spacing:.11em !important}' +
    'legend{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif !important;font-weight:700 !important;' +
    'font-size:calc(var(--font-5,17.5px) * var(--FONT-ADJUST-HEADING,1)) !important;text-transform:uppercase !important;letter-spacing:.11em !important;' +
    'color:#3f3f40 !important}' +
    'input,textarea{padding-left:0 !important;padding-right:0 !important}' +
    'button[class*="_selectToggle"]{padding-left:0 !important;padding-right:0 !important}' +
    '[class*="_formInputFieldLabel"]{left:0 !important}' +
    'button[class*="_formSubmitButton"]{font-family:"Sofia Sans",sans-serif !important;' +
    'font-weight:500 !important;font-size:11.7px !important;text-transform:uppercase !important;' +
    'letter-spacing:.11em !important}' +
    '[class*="_formDisclaimer"]{display:none !important}' +
    /* Phone width (Gaurav 2026-09-17): the app lays the form out as a centred 2 x 320px grid
       and on a 375px screen that collapsed to one 242px column with 50px dead on each side.
       Below 750px the container and the form take the full block width. */
    '@media (max-width:749px){[class*="_container_"]{grid-template-columns:100% !important;justify-content:stretch !important}' +
    '[class*="_formContainer_"]{grid-template-columns:1fr !important;max-width:none !important;width:100% !important;margin:0 !important;min-width:0 !important}' +
    '[class*="_gridItem_"]{width:100% !important;max-width:none !important}}';
  function paint(host) {
    var sr = host.shadowRoot;
    if (!sr || sr.querySelector('style[data-kiwi-forms]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-kiwi-forms', '');
    s.textContent = CSS;
    sr.appendChild(s);
  }
  var tries = 0;
  var timer = setInterval(function () {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    var ready = 0, i;
    for (i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) { paint(hosts[i]); ready++; }
    }
    if ((hosts.length > 0 && ready === hosts.length) || ++tries > 40) clearInterval(timer);
  }, 250);
})();

/* Kiwi: sideways-scroll cue for information tables on phones (2026-09-17). A table wider than
   its scroller got no hint that more columns exist; the right edge simply cut a word in half.
   Any scroller whose content is wider than itself gets an inset edge shadow (class
   kiwi-scroll--more, styled in kiwi-brand.css) and one short note under it. The shadow clears
   once the reader has scrolled to the end. Scrollers that already carry a "Scroll horizontally"
   note (the size chart pages) get the shadow only.
   2026-09-21: .rte__table-wrapper added, the theme's wrapper around every page-body table (the
   size chart pages and the PDP size chart pop-up). The size chart pages keep their own line a
   few paragraphs below the table, never as the next sibling, so any following sibling in the
   same block now counts. A ResizeObserver re-checks a scroller that was hidden when the page
   loaded (the pop-up) the moment it opens.
   2026-09-23: the size chart app block tables on the Sizing & Care page added. Those tables are
   their own scroll container (assets/kiwi-mobile-tables.css makes each table the scroller so the
   titles around it stay put), so the table element is what is listed, not a wrapper div. They
   scrolled sideways with no cue at all. One device covers every table on the site; there is no
   second one.
   AV 2026-09-24: the note now follows the measurement both ways. It was added the first time a
   box overflowed and never removed, so any moment of narrow layout (a window resized narrower
   and back, a phone rotated, a page captured) left "Scroll sideways to see every column." under
   tables that fit, e.g. every table on the Safety page at 1440. The note shows only while its
   box really is wider than the screen gives it; the edge shadow already worked this way.
   2026-09-29: the product page Inventory table's scroller (.kiwi-pdp-inv__scroll,
   blocks/ai_gen_block_dd15706.liquid) added. Its trade columns ran past a 390px screen and
   were clipped by the page, with no scroller and no cue. */
(function () {
  'use strict';
  var SEL = '.kiwi-jt__scroll, .kiwi-ct__scroll, .khm__scroll, .ksm__scroll, .kiwi-mx__s, .kc-scroll, .kiwi-td__scroll, .kiwi-st__scroll, .kcg__scroll, .kg__scroll, .kiwi-qb__scroll, .ksf__scroll, .kiwi-pdp-inv__scroll, .rte__table-wrapper, div[class*="kiwi-scc__content-"] table, div[class*="ai-product-search-display__content-"] table';
  function arm(box) {
    if (box.dataset.kiwiScrollDone) return;
    box.dataset.kiwiScrollDone = '1';
    var note = null;
    /* 2026-10-27 (Gaurav: "some tables still try to horizontal scroll even though the whole table
       fits on the screen"). Measured at 390px: fourteen collection compare grids ran 7 to 26px past
       their scroller and the glove size chart 5px, so each one dragged sideways a few pixels. When a
       table overflows, kiwi-fit (kiwi-brand.css, phones only) tightens the cell padding and lets the
       compare grid's product column give back some width. If that makes it fit, it stays; if not,
       the class comes off and the table scrolls as before with its edge cue. Re-measured only when
       the scroller's width changes, so a phone's address bar showing or hiding costs nothing. */
    var fitW = -1;
    function fit() {
      if (box.clientWidth === fitW) return;
      fitW = box.clientWidth;
      box.classList.remove('kiwi-fit');
      if (box.scrollWidth > box.clientWidth) {
        box.classList.add('kiwi-fit');
        if (box.scrollWidth > box.clientWidth) box.classList.remove('kiwi-fit');
      }
    }
    function check(e) {
      if (!e || e.type !== 'scroll') fit();
      var more = box.scrollWidth > box.clientWidth + 4;
      var atEnd = box.scrollLeft + box.clientWidth >= box.scrollWidth - 4;
      box.classList.toggle('kiwi-scroll--more', more && !atEnd);
      if (note) note.style.display = more ? '' : 'none';
      if (more && !box.dataset.kiwiScrollNoted) {
        box.dataset.kiwiScrollNoted = '1';
        var has = false;
        for (var sib = box.nextElementSibling; sib && !has; sib = sib.nextElementSibling) {
          has = /scroll (horizontally|sideways)/i.test(sib.textContent || '');
        }
        if (!has) {
          var p = document.createElement('p');
          p.className = 'kiwi-scroll__note';
          p.textContent = 'Scroll sideways to see every column.';
          box.insertAdjacentElement('afterend', p);
          note = p;
        }
      }
    }
    box.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    if (window.ResizeObserver) { new ResizeObserver(check).observe(box); }
    check();
  }
  function run() { [].forEach.call(document.querySelectorAll(SEL), arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  /* 2026-09-24 (size charts, Gaurav: no size chart may ever make a page scroll sideways). The
     Sizing & Care product search draws the chosen product's size chart after the page has
     loaded, so run() had already passed and its table scrolled sideways with no edge cue and no
     note. Any table added to the page later is now armed the moment it arrives. arm() skips a
     box it has seen, so a repeat pass costs nothing. */
  if (window.MutationObserver) {
    var late = 0;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1 && (n.tagName === 'TABLE' || n.querySelector('table'))) {
            clearTimeout(late); late = setTimeout(run, 50); return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Kiwi: per-product collapse for the portal inventory tables on phones (2026-09-18). The
   Wholesale Pricing Sheet and the Inventory page render every variant as its own stacked card
   under 750px, which made those pages 150,000 to 340,000px tall. Rows are grouped by
   data-kw-product. Owner's call 2026-09-18: the FIRST product on the page opens with every
   variant showing, so the reader sees a worked example; every other product is fully closed,
   its own first-variant cells included (class kiwi-vc--closed on the product row,
   kiwi-vc--hide on the rest, both styled in kiwi-brand.css inside the phone media query).
   The control is the same one the long information tables use (first IIFE): the theme's
   underlined text link, .kiwi-more__wrap holding button.text-link-bare.kiwi-more__btn,
   reading "View all N variants" and "Show fewer". It rides in its own tr.kiwi-vc__foot
   inserted after the group's last row, so it sits at the foot of the product card when the
   group is closed and under the last variant when it is open; that row is phone-only, hidden
   at every other width from kiwi-brand.css. A product with one variant gets no link and is
   never closed. The section's own search sets inline display on rows, so a search opens the
   products it matches and hides their foot rows with it; clearing it returns every product to
   its default state. Since 2026-09-22 the Wholesale Pricing Sheet runs this at every width
   (Gaurav); the Inventory page stays phone only. On wider screens the product cell's rowspan
   follows the rows on show, and kiwi-brand.css shows the foot row as a table row. */
(function () {
  'use strict';
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function label(n, open) { return open ? 'Show fewer' : 'View all ' + n + (n === 1 ? ' variant' : ' variants'); }
  function setup(table) {
    if (table.dataset.kiwiVcDone) return;
    table.dataset.kiwiVcDone = '1';
    var rows = [].slice.call(table.querySelectorAll('tbody tr[data-kw-product]'));
    var groups = {}, order = [];
    rows.forEach(function (r) {
      var k = r.getAttribute('data-kw-product');
      if (!groups[k]) { groups[k] = []; order.push(k); }
      groups[k].push(r);
    });
    var api = [];
    order.forEach(function (k, idx) {
      var g = groups[k], first = g[0], last = g[g.length - 1];
      var pcell = first.querySelector('td[rowspan]');
      if (g.length < 2) { api.push({ sync: function () {} }); return; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'text-link-bare kiwi-more__btn';
      var box = document.createElement('div');
      box.className = 'kiwi-more__wrap';
      box.appendChild(btn);
      var cell = document.createElement('td');
      cell.colSpan = first.children.length;
      cell.appendChild(box);
      var foot = document.createElement('tr');
      foot.className = 'kiwi-vc__foot';
      foot.appendChild(cell);
      last.insertAdjacentElement('afterend', foot);
      var dflt = idx === 0, open = dflt;
      function apply() {
        first.classList.toggle('kiwi-vc--closed', !open);
        if (pcell) pcell.rowSpan = open ? g.length : 1;
        for (var i = 1; i < g.length; i++) g[i].classList.toggle('kiwi-vc--hide', !open);
        btn.textContent = label(g.length, open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function () {
        open = !open; apply();
        if (!open) { var top = first.getBoundingClientRect().top + window.scrollY - 120; if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' }); }
      });
      apply();
      api.push({
        sync: function (q) {
          var shown = first.style.display !== 'none';
          foot.style.display = shown ? '' : 'none';
          open = q ? shown : dflt;
          apply();
        }
      });
    });
    var host = table.closest('[class*="ai-inventory-table-"]') || table.parentNode;
    var input = host.querySelector('input[type="search"]');
    if (input) {
      input.addEventListener('input', function () {
        // after the section's own handler has set inline display on the rows
        setTimeout(function () {
          var q = input.value.trim();
          api.forEach(function (a) { a.sync(q); });
        }, 0);
      });
    }
  }
  function run() {
    // The Wholesale Pricing Sheet collapses at every width (Gaurav 2026-09-22); Inventory on phones only.
    [].forEach.call(document.querySelectorAll('table[class*="ai-inventory-table__table-"]'), function (t) {
      // the product page Inventory table is folded by the first IIFE, never grouped here
      if (t.closest('.kiwi-pdp-inv')) return;
      if (/__pricing_sheet/.test(t.className) || !MQ || MQ.matches) setup(t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  if (MQ && MQ.addEventListener) MQ.addEventListener('change', run);
  document.addEventListener('shopify:section:load', run);
})();

/* Kiwi: the filter bar (.kqf), open and close. One group open at a time: clicking a group
   title opens its values inline to its right and closes any other. Moved here 2026-09-21 from
   snippets/kiwi-quick-filters.liquid, because the same bar is now the filter UI on the
   collection pages, the Product Sheet and the Spec Finder (owner: the collection bar is the
   house filter style). Delegated on the document so it survives the collection's AJAX
   re-render, and guarded so it can never bind twice. Toggling a VALUE is each page's own:
   Shopify's filter URLs on a collection, the page script on the Product Sheet and Spec Finder. */
(function () {
  'use strict';
  if (window.kiwiQuickFiltersBound) return;
  window.kiwiQuickFiltersBound = true;
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-kqf-toggle]');
    if (!button) return;
    var group = button.closest('.kqf__group');
    var row = button.closest('[data-kqf]');
    if (!group || !row) return;
    var wasOpen = group.classList.contains('is-open');
    [].forEach.call(row.querySelectorAll('.kqf__group'), function (other) {
      other.classList.remove('is-open');
      var t = other.querySelector('[data-kqf-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      group.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }
  });
})();

/* Kiwi: hero banner height, set before first paint (2026-09-23). Gaurav: "every time i click on
   the dealers link on the menu and it goes to wholesale registration the image banner header
   glitches a little while trying to fit correctly to the screen". The theme sizes a hero whose
   text is taller than its image (.js-overflow-container) in its own preventOverflow, which runs
   on window load. On a page carrying app scripts that is late (about 3.4s on Wholesale
   Registration), so the banner painted short and then jumped to its full height. This runs the
   same measurement at DOMContentLoaded and again once the web fonts are in, with the theme's
   own formula (tallest .js-overflow-content plus its margins, at least 64px, plus
   var(--menu-height)), so the banner is the right height from the first frame and the theme's
   later pass changes nothing. Measured on the draft: settles at about 1.1s, before first
   paint, instead of 3.4s. */
(function () {
  'use strict';
  function fit() {
    [].forEach.call(document.querySelectorAll('.js-overflow-container'), function (f) {
      var t = 0, pad = 64;
      [].forEach.call(f.querySelectorAll('.js-overflow-content'), function (w) {
        if (w.offsetHeight > t) {
          var cs = getComputedStyle(w);
          var m = (parseInt(cs.marginTop, 10) || 0) + (parseInt(cs.marginBottom, 10) || 0);
          if (m > pad) pad = m;
          t = w.offsetHeight;
        }
      });
      if (!t) return;
      [f].concat([].slice.call(f.querySelectorAll('[data-overflow-background]'))).forEach(function (el) {
        el.style.setProperty('min-height', 'calc(' + (t + pad) + 'px + var(--menu-height))');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();

/* Kiwi: sticky head row on every long table (2026-09-23 b). Gaurav: "the freezing header is good
   on the wholesale pricing sheet, but that freezing header should be applied to all relevant
   tables", and the line under it must be the same line as every other row. A table with more
   than 10 body rows and a single head row gets .kiwi-sticky from 750px up (styled in
   kiwi-brand.css, B3). A side-scroll wrapper would make itself the sticky container and the head
   would never move, so while the table fits its wrapper, that wrapper and any other clipping
   ancestor switch to overflow-x: clip, which clips without scrolling; if the table outgrows it
   the wrapper gets its own overflow back and scrolls as before. .is-stuck is set only while the
   head is pinned, so the 1px line is drawn once, by the border at rest and by the cell while
   pinned. The theme's header is directional (it slides back in on scroll up and sits fixed at
   the top), so --kiwi-sticky-top follows its visible bottom edge and the head row sits under it.
   AV 2026-09-24: the Shop by Trade "Where the risk actually is" table (.kiwi-td, 16 rows) added;
   a re-sorted compare grid (.kcg, swapped in by its section) is picked up when it arrives.
   d1 2026-09-29, Gaurav: "on the order sheet for sales rep when the order is large the order
   headers should freeze so they can be seen when scrolling through the order". The Order Sheet's
   order table (.kqb__t) and the paste review table (.kiwi-qo, also the Quick Order page) join the
   list, and are re-checked whenever their rows change. The order table is 1,162px at its
   narrowest, so below about 1,190px it scrolls sideways and the wrapper has to keep its own
   overflow, which would hold the head inside it. For these two tables only, while they scroll
   sideways, a copy of the head row is pinned at the same place instead (div.kiwi-sticky-copy,
   position fixed under the theme header, clipped to the wrapper, moved with its sideways scroll,
   each column the width of the real one). Same rule as above: from 750px up, more than 10 rows,
   one 1px #d9d9d9 line under it.
   d4 2026-09-29, Gaurav: "if you try to scroll while over the table you can only scroll in the
   table, and not the page ... i think changing over to frozen headers and no scrolling within
   tables at least vertically is smarter". Size charts join the list (the tables the unit toggle
   marks data-kiwi-units="yes"). They have no thead: their first row is the head, so it takes
   .kiwi-sticky__head. A size chart inside the Sizing & Care carousel sits in a track that has
   to stay a sideways scroller, so it always gets the pinned copy, placed at the end of the page
   in a box carrying the chart's own content class (its type is scoped to that class), and
   moved with the carousel as well. The copy's box is the part of the table actually on screen,
   so the charts on the other slides never show. A table that gets a copy no longer also gets
   the in-place sticky head (inside a scroller that head would be held by the scroller, not the
   page). Tables inside a pop-up (.modal__container) are left alone; the pop-up scrolls itself.
   2026-10-09, Gaurav: frozen head rows on phones too. Below 750px the same tables (more than 10
   rows, one head row) get the pinned copy, never the in-place sticky head. */
(function () {
  'use strict';
  var CHART = 'table[data-kiwi-units="yes"]';
  /* 2026-09-30 (e8, Gaurav: "comco pqge heqder doestn freeze"): .krp__fold table, the per-style commission
     breakdown on Kiwi ComCo and the Rep Playbook, joins the frozen head rule. */
  var SEL = '.ksf__t, .ksm table, .kcg table, .kiwi-ct table, .kiwi-jt table, .khm table, .kiwi-td table, table[class*="ai-inventory-table__table-"], .kqb__t, .kiwi-qo table, .krp__fold table, ' + CHART;
  var COPY = '.kqb__t, .kiwi-qo table, ' + CHART;
  var TRACK = '[data-kw-track]';
  var GROUP = '.rte, [class*="kiwi-scc__content-"], [class*="ai-product-search-display__content-"]';
  var MQ = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  var list = [], copies = [];
  function headOf(t) {
    if (t.tHead) return t.tHead.rows.length === 1 ? t.tHead.rows[0] : null;
    return t.getAttribute('data-kiwi-units') === 'yes' && t.rows.length ? t.rows[0] : null;
  }
  function wanted(t) {
    if (t.closest('.kiwi-pdp-inv, .modal__container, .kiwi-sticky-copy')) return false;
    if (!headOf(t)) return false;
    var n = 0;
    if (t.tHead) { for (var i = 0; i < t.tBodies.length; i++) n += t.tBodies[i].rows.length; }
    else n = t.rows.length - 1;
    return n > 10;
  }
  function wrappers(t, on) {
    for (var el = t.parentElement; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      var cs = getComputedStyle(el);
      var clips = el.hasAttribute('data-kiwi-sticky-ov') || /auto|scroll|hidden/.test(cs.overflowX + ' ' + cs.overflowY);
      if (!clips) continue;
      if (!el.hasAttribute('data-kiwi-sticky-ov')) el.setAttribute('data-kiwi-sticky-ov', el.style.overflowX + '|' + el.style.overflowY);
      var fits = t.offsetWidth <= el.clientWidth + 1;
      if (on && fits) { el.style.overflowX = 'clip'; el.style.overflowY = 'visible'; }
      else { var o = el.getAttribute('data-kiwi-sticky-ov').split('|'); el.style.overflowX = o[0]; el.style.overflowY = o[1]; }
    }
  }
  function scroller(t) {
    for (var el = t.parentElement; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      if (/auto|scroll/.test(getComputedStyle(el).overflowX) && el.scrollWidth > el.clientWidth + 1) return el;
    }
    return null;
  }
  function copyFor(t, sc) {
    var c = t._kiwiCopy, h = headOf(t);
    if (!c || !c.isConnected) {
      c = document.createElement('div');
      c.className = 'kiwi-sticky-copy';
      c.setAttribute('aria-hidden', 'true');
      c.hidden = true;
      var tb = document.createElement('table');
      tb.setAttribute('data-kiwi-units', 'no');
      tb.setAttribute('data-kiwi-scroll-done', '1');
      var track = t.closest(TRACK);
      if (track) {
        var g = t.closest(GROUP), box = document.createElement('div');
        if (g) box.className = g.className;
        box.style.cssText = 'margin:0;padding:0;border:0;overflow:visible;background:none;';
        box.appendChild(tb);
        c.appendChild(box);
        document.body.appendChild(c);
        if (!track._kiwiCopyScroll) { track._kiwiCopyScroll = 1; track.addEventListener('scroll', onScroll, { passive: true }); }
      } else {
        c.appendChild(tb);
        sc.parentNode.insertBefore(c, sc.nextSibling);
      }
      t._kiwiCopy = c;
      t._kiwiCopyTable = tb;
    }
    var ct = t._kiwiCopyTable, head;
    if (t.tHead) head = t.tHead.cloneNode(true);
    else { head = document.createElement('tbody'); head.appendChild(h.cloneNode(true)); }
    ct.className = t.className.replace(/(^|\s)(kiwi-sticky|is-stuck)(?=\s|$)/g, ' ').trim();
    ct.innerHTML = '';
    ct.appendChild(head);
    [].forEach.call(ct.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
    [].forEach.call(ct.querySelectorAll('.kiwi-sticky__head'), function (e) { e.classList.remove('kiwi-sticky__head'); });
    ct.style.width = t.offsetWidth + 'px';
    var from = h.cells, to = head.rows[0].cells;
    for (var i = 0; i < from.length && i < to.length; i++) {
      to[i].style.width = from[i].getBoundingClientRect().width + 'px';
      // the copy's head is the last row of its table, and the size chart rule drops the last
      // row's line with !important (kiwi-brand.css), so the head's own line is set the same way
      var cs = getComputedStyle(from[i]);
      to[i].style.setProperty('border-bottom', cs.borderBottomWidth + ' ' + cs.borderBottomStyle + ' ' + cs.borderBottomColor, 'important');
    }
    if (!sc._kiwiCopyScroll) { sc._kiwiCopyScroll = 1; sc.addEventListener('scroll', onScroll, { passive: true }); }
    t._kiwiScroller = sc;
  }
  function place(t, top) {
    var c = t._kiwiCopy, sc = t._kiwiScroller, h = headOf(t);
    if (!c || !sc || !h) return;
    var r = t.getBoundingClientRect(), s = sc.getBoundingClientRect();
    // the copy covers only the part of the table that is on screen inside its scroller
    var L = Math.max(s.left, r.left), R = Math.min(s.left + sc.clientWidth, r.right);
    var on = r.top < top && r.bottom > top + h.offsetHeight && R - L >= 1;
    if (!on) { if (!c.hidden) c.hidden = true; return; }
    c.hidden = false;
    c.style.top = top + 'px';
    c.style.left = Math.round(L) + 'px';
    c.style.width = Math.round(R - L) + 'px';
    t._kiwiCopyTable.style.transform = 'translateX(' + Math.round(r.left - L) + 'px)';
  }
  var hdr = null;
  function headerBottom() {
    if (!hdr || !hdr.isConnected) hdr = document.querySelector('header.theme__header');
    if (!hdr) return 0;
    var wrap = hdr.closest('.header__wrapper');
    if (!wrap || getComputedStyle(wrap).position !== 'fixed') return 0;
    return Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
  }
  var lastTop = -1;
  function tick() {
    if (!list.length && !copies.length) return;
    var top = headerBottom();
    if (top !== lastTop) { document.documentElement.style.setProperty('--kiwi-sticky-top', top + 'px'); lastTop = top; }
    for (var i = 0; i < list.length; i++) {
      var t = list[i];
      var r = t.getBoundingClientRect();
      var hr = headOf(t), h = hr ? hr.offsetHeight : 0;
      t.classList.toggle('is-stuck', r.top < top && r.bottom > top + h);
    }
    for (var k = 0; k < copies.length; k++) place(copies[k], top);
  }
  var raf = 0, settle = 0;
  function onScroll() {
    if (!raf) raf = requestAnimationFrame(function () { raf = 0; tick(); });
    // the header slides in and out over about a third of a second; follow it to rest
    clearTimeout(settle); settle = setTimeout(function () { tick(); setTimeout(tick, 200); }, 150);
  }
  function run() {
    var on = !MQ || MQ.matches;
    list = [];
    copies.forEach(function (t) { if (t._kiwiCopy) t._kiwiCopy.hidden = true; });
    copies = [];
    [].forEach.call(document.querySelectorAll(SEL), function (t) {
      var h = headOf(t);
      if (!wanted(t)) {
        t.classList.remove('kiwi-sticky', 'is-stuck');
        if (h) h.classList.remove('kiwi-sticky__head');
        return;
      }
      var track = t.closest(TRACK);
      if (!track) wrappers(t, on);
      var sc = on && t.matches(COPY) ? scroller(t) : null;
      /* 2026-10-09, Gaurav: "on mobile tables when expanded dont have frozen headers, so its
         useless". Under 750px every long table gets the pinned copy of its head row, whether it
         scrolls sideways or fits: the scroller's own overflow would hold an in-place sticky head,
         so the copy is the one device that works on a phone. A table whose head row is hidden on
         phones (the Inventory and Pricing Sheet cards) is left alone. */
      if (!on && h.offsetHeight > 0) sc = scroller(t) || t.parentElement;
      var native = on && !sc && !track;
      t.classList.toggle('kiwi-sticky', native);
      if (!native) t.classList.remove('is-stuck');
      if (!t.tHead) h.classList.toggle('kiwi-sticky__head', native);
      if (native) list.push(t);
      if (sc) { copyFor(t, sc); copies.push(t); }
    });
    tick();
  }
  var rt = 0;
  function later() { clearTimeout(rt); rt = setTimeout(run, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', later);
  window.addEventListener('resize', later);
  window.addEventListener('scroll', onScroll, { passive: true });
  if (MQ && MQ.addEventListener) MQ.addEventListener('change', later);
  document.addEventListener('shopify:section:load', later);
  document.addEventListener('kiwi:units', later);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.kiwi-more__btn')) later(); });
  if (window.MutationObserver) {
    new MutationObserver(function (l) {
      for (var i = 0; i < l.length; i++) {
        var g = l[i].target;
        if (g && g.nodeType === 1 && g.closest && !g.closest('.kiwi-sticky-copy') && g.closest(COPY)) { later(); return; }
        for (var j = 0; j < l[i].addedNodes.length; j++) {
          var n = l[i].addedNodes[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('kcg')) { later(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Kiwi: the filter row above the portal tables (2026-09-23 b). Gaurav: "the filters that we made,
   the new filter row, should show above all relevant tables". Draws the collection page's bar
   (.kqf, opened and closed by the .kqf script above) into div[data-kpf] on the Inventory page
   and the Wholesale Pricing Sheet, laid out as the Spec Finder's: Category and Stock, a sub row
   for the chosen category (toe for footwear, ANSI class for hi-vis, cut level for gloves), Clear
   at the right, the count under it. Rows carry data-kpf-cat, data-kpf-sub and data-kpf-stock
   from Liquid; a product is kept or dropped as a whole, its variant rows and its View all row
   with it, through .kpf--out, so the section's own search (inline display) and the variant
   collapse (.kiwi-vc--hide) keep working on top. On the Pricing Sheet a category table with
   nothing left in it hides too. Clear also empties the search, as on the Spec Finder. */
(function () {
  'use strict';
  var CATS = ['Footwear', 'Hi-Vis Apparel', 'Work Gloves'];
  var SUB = { 'Footwear': ['Composite toe', 'Steel toe', 'Soft toe'], 'Hi-Vis Apparel': ['Class 3', 'Class 2', 'Not rated'], 'Work Gloves': ['A5', 'A4', 'A1', 'Not rated'] };
  var SUBLBL = { 'Footwear': 'Toe', 'Hi-Vis Apparel': 'ANSI class', 'Work Gloves': 'Cut level' };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function val(axis, v, label, on) {
    return '<button type="button" class="kqf__val' + (on ? ' is-on' : '') + '" data-kpf-axis="' + axis + '" data-kpf-val="' + esc(v) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(label) + '</button>';
  }
  function group(title, open, inner, chev) {
    return '<div class="kqf__group' + (open ? ' is-open' : '') + '"><button type="button" class="kqf__btn" data-kqf-toggle aria-expanded="' + (open ? 'true' : 'false') + '"><span>' + esc(title) + '</span><span class="kqf__chev">' + chev + '</span></button><div class="kqf__values">' + inner + '</div></div>';
  }
  function setup(box) {
    if (box.hasAttribute('data-kpf-done')) return;
    box.setAttribute('data-kpf-done', '');
    var host = box.closest('[class*="ai-inventory-table-"]') || box.parentElement;
    var tpl = box.querySelector('template[data-kpf-chev]');
    var CHEV = tpl ? tpl.innerHTML : '';
    var groups = [], byKey = {};
    [].forEach.call(host.querySelectorAll('tbody tr[data-kw-product]'), function (r) {
      var k = r.getAttribute('data-kw-product');
      if (!byKey[k]) {
        byKey[k] = { rows: [], cat: r.getAttribute('data-kpf-cat') || '', sub: r.getAttribute('data-kpf-sub') || '', stock: r.getAttribute('data-kpf-stock') === '1' };
        groups.push(byKey[k]);
      }
      byKey[k].rows.push(r);
    });
    if (!groups.length) return;
    var cats = CATS.filter(function (c) { return groups.some(function (g) { return g.cat === c; }); });
    var st = { cat: '', sub: '', stock: false };
    var catVals = val('cat', '', 'All', true) + cats.map(function (c) { return val('cat', c, c, false); }).join('');
    box.innerHTML =
      '<div class="kpf__line"><div class="kpf__filt">' +
      '<div class="kqf kqf--solo" data-kqf role="group" aria-label="Filters">' +
      group('Category', true, catVals, CHEV) +
      group('Stock', false, val('stock', 'in', 'In stock only', false), CHEV) +
      '</div>' +
      '<div class="kqf kqf--solo kqf--sub" data-kqf data-kpf-sub hidden role="group" aria-label="Filters for the chosen category"></div>' +
      // 2026-10-26 (Gaurav): no Clear button; the collection page has none, and All already clears.
      '</div></div>' +
      '<div class="kpf__foot"><p class="kpf__count"></p></div>';
    var subRow = box.querySelector('[data-kpf-sub]');
    var count = box.querySelector('.kpf__count');
    var input = host.querySelector('input[type="search"]');
    function drawSub() {
      if (!st.cat) { subRow.hidden = true; subRow.innerHTML = ''; return; }
      var have = (SUB[st.cat] || []).filter(function (v) { return groups.some(function (g) { return g.cat === st.cat && g.sub === v; }); });
      if (have.length < 2) { subRow.hidden = true; subRow.innerHTML = ''; return; }
      subRow.innerHTML = group(SUBLBL[st.cat] || 'Type', true, have.map(function (v) { return val('sub', v, v, st.sub === v); }).join(''), CHEV);
      subRow.hidden = false;
    }
    function mark() {
      [].forEach.call(box.querySelectorAll('[data-kpf-axis]'), function (b) {
        var a = b.getAttribute('data-kpf-axis'), v = b.getAttribute('data-kpf-val');
        var on = a === 'cat' ? st.cat === v : a === 'sub' ? st.sub === v : st.stock;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function apply() {
      var shown = 0;
      groups.forEach(function (g) {
        var pass = (!st.cat || g.cat === st.cat) && (!st.sub || g.sub === st.sub) && (!st.stock || g.stock);
        if (pass) shown++;
        g.rows.forEach(function (r) { r.classList.toggle('kpf--out', !pass); });
        var n = g.rows[g.rows.length - 1].nextElementSibling;
        if (n && n.classList.contains('kiwi-vc__foot')) n.classList.toggle('kpf--out', !pass);
      });
      [].forEach.call(host.querySelectorAll('.kwps__cat'), function (c) {
        c.classList.toggle('kpf--out', !c.querySelector('tbody tr[data-kw-product]:not(.kpf--out)'));
      });
      var noun = groups.length === 1 ? ' style' : ' styles';
      count.innerHTML = shown === groups.length ? '<b>' + groups.length + '</b>' + noun : '<b>' + shown + '</b> of ' + groups.length + noun;
      mark();
      window.dispatchEvent(new Event('resize'));
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-kpf-axis], [data-kpf-clear]');
      if (!b) return;
      if (b.hasAttribute('data-kpf-clear')) {
        st = { cat: '', sub: '', stock: false };
        if (input && input.value) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); }
        drawSub(); apply(); return;
      }
      var a = b.getAttribute('data-kpf-axis'), v = b.getAttribute('data-kpf-val');
      if (a === 'cat') { st.cat = (st.cat === v) ? '' : v; st.sub = ''; drawSub(); }
      else if (a === 'sub') { st.sub = (st.sub === v) ? '' : v; }
      else { st.stock = !st.stock; }
      apply();
    });
    drawSub(); apply();
  }
  function run() { [].forEach.call(document.querySelectorAll('[data-kpf]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* Kiwi: inches or centimeters on every size chart (d1, 2026-09-29; d2 the same day). Gaurav: "is
   there a way to toggle between inches and cm on size charts", then (d2) "the toggle should be off
   to the right side and it should be toggles ... like a light toggle instead of individual
   separate buttons, and the toggles should be in line with the page title". A size chart is a
   table whose first cell reads Size or Men's Size and that holds inch figures (23", 32-34",
   9.69 in) or an inch column beside a metric one. Each chart block gets one IN / CM toggle
   (d3: one box in the product page's option button look, the charcoal fill sliding to the unit
   in use) at the right end of the block's title line: the heading just before the block (a size
   chart page's title, a Sizing & Care chart title, Find your size), else the chart's own short
   caption (the product page tab and pop-up read "Size Chart"), else a line of its own above the
   chart. The title keeps its place and alignment; its margins move to the row. Every toggle on
   the page moves together: a click on IN or CM picks that unit, a key press on the toggle flips
   it, and the choice is remembered on the device. Centimeters are inches x 2.54, one decimal for
   a single figure and whole numbers for a range. A chart that already prints an inch column
   beside a metric one (the boot charts, Find your size) shows one of the two. Inches is the
   default, and inches puts each cell back exactly as written. Styled in kiwi-brand.css, D1. */
(function () {
  'use strict';
  var KEY = 'kiwi-units', unit = 'in', charts = [];
  try { if (localStorage.getItem(KEY) === 'cm') unit = 'cm'; } catch (e) {}
  var FIG = /^(\d+(?:\.\d+)?)(?:\s*[-–]\s*(\d+(?:\.\d+)?))?\s*(?:"|”|″|in\.?)$/i;
  var IN_H = /([\(\[](in|inch|inches)[\)\]]|,\s*in)\s*$/i;
  var MET_H = /([\(\[](cm|mm|centimet(er|re)s|millimet(er|re)s)[\)\]]|,\s*(cm|mm))\s*$/i;
  var GROUP = '.rte, [class*="kiwi-scc__content-"], [class*="ai-product-search-display__content-"]';
  var STOP = '[id^="shopify-section"], section, body, .modal__container';
  function txt(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }
  function num(n, whole) { return String(whole ? Math.round(n) : Math.round(n * 10) / 10); }
  function toCm(m) {
    var a = parseFloat(m[1]) * 2.54;
    return m[2] ? num(a, true) + '-' + num(parseFloat(m[2]) * 2.54, true) + ' cm' : num(a) + ' cm';
  }
  function prep(t) {
    t.setAttribute('data-kiwi-units', 'no');
    var rows = t.rows;
    if (!rows.length || !rows[0].cells.length) return false;
    if (!/^(men.?s )?size$/i.test(txt(rows[0].cells[0]))) return false;
    var inCols = [], metCols = [], figs = [];
    [].forEach.call(rows[0].cells, function (c, i) {
      var s = txt(c);
      if (IN_H.test(s)) inCols.push(i); else if (MET_H.test(s)) metCols.push(i);
    });
    var cols = inCols.length > 0 && metCols.length > 0;
    if (!cols) { inCols = []; metCols = []; }
    for (var r = 1; r < rows.length; r++) {
      for (var i = 0; i < rows[r].cells.length; i++) {
        if (inCols.indexOf(i) > -1 || metCols.indexOf(i) > -1) continue;
        var c = rows[r].cells[i], m = FIG.exec(txt(c));
        if (m) figs.push({ c: c, html: c.innerHTML, cm: toCm(m) });
      }
    }
    if (!figs.length && !cols) return false;
    t.setAttribute('data-kiwi-units', 'yes');
    charts.push({ t: t, figs: figs, inCols: inCols, metCols: metCols });
    return true;
  }
  function heading(g) {
    for (var e = g, n = 0; e && n < 4; e = e.parentElement, n++) {
      if (e.matches && e.matches(STOP)) break;
      var p = e.previousElementSibling;
      if (p && /^H[1-4]$/.test(p.tagName)) return p;
    }
    return null;
  }
  function caption(g, t) {
    var f = g.firstElementChild, s = txt(f);
    if (f && f.tagName === 'P' && s.length && s.length <= 40 && (f.compareDocumentPosition(t) & 4)) return f;
    return null;
  }
  function toggle() {
    var w = document.createElement('div');
    w.className = 'kiwi-units';
    w.innerHTML = '<button type="button" class="kiwi-units__sw" role="switch" aria-checked="false" aria-label="Show centimeters">' +
      '<span class="kiwi-units__l" data-kiwi-unit="in">In</span><span class="kiwi-units__l" data-kiwi-unit="cm">Cm</span></button>';
    return w;
  }
  function mount(g, t) {
    if (g.hasAttribute('data-kiwi-units-g')) return;
    g.setAttribute('data-kiwi-units-g', '1');
    var ti = heading(g) || caption(g, t);
    if (ti && ti.parentElement && ti.parentElement.classList.contains('kiwi-units-row')) return;
    var row = document.createElement('div');
    row.className = 'kiwi-units-row';
    if (ti) {
      var cs = getComputedStyle(ti);
      if (cs.textAlign === 'center') row.classList.add('kiwi-units-row--c');
      row.style.marginTop = cs.marginTop;
      row.style.marginBottom = cs.marginBottom;
      ti.parentNode.insertBefore(row, ti);
      row.appendChild(ti);
      ti.style.margin = '0';
    } else {
      row.classList.add('kiwi-units-row--r');
      var at = t.closest('.rte__table-wrapper') || t;
      at.parentNode.insertBefore(row, at);
    }
    row.appendChild(toggle());
  }
  function show(e) {
    var cm = unit === 'cm';
    e.figs.forEach(function (f) { if (cm) f.c.textContent = f.cm; else f.c.innerHTML = f.html; });
    if (!e.inCols.length) return;
    [].forEach.call(e.t.rows, function (row) {
      e.inCols.forEach(function (i) { if (row.cells[i]) row.cells[i].style.display = cm ? 'none' : ''; });
      e.metCols.forEach(function (i) { if (row.cells[i]) row.cells[i].style.display = cm ? '' : 'none'; });
    });
  }
  function paint() {
    charts = charts.filter(function (e) { return e.t.isConnected; });
    charts.forEach(show);
    [].forEach.call(document.querySelectorAll('.kiwi-units'), function (w) {
      var sw = w.querySelector('.kiwi-units__sw');
      if (sw) sw.setAttribute('aria-checked', unit === 'cm' ? 'true' : 'false');
      [].forEach.call(w.querySelectorAll('.kiwi-units__l'), function (l) {
        l.classList.toggle('is-on', l.getAttribute('data-kiwi-unit') === unit);
      });
    });
    // the frozen head script (above) re-measures the charts whose cells just changed
    try { document.dispatchEvent(new CustomEvent('kiwi:units')); } catch (e) {}
  }
  function scan() {
    var fresh = false;
    [].forEach.call(document.querySelectorAll('table:not([data-kiwi-units])'), function (t) {
      if (prep(t)) { mount(t.closest(GROUP) || t.parentElement, t); fresh = true; }
    });
    if (fresh) paint();
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.kiwi-units__sw, .kiwi-units__l');
    if (!s) return;
    var next = s.classList.contains('kiwi-units__sw') ? (unit === 'cm' ? 'in' : 'cm') : s.getAttribute('data-kiwi-unit');
    if (next !== 'cm') next = 'in';
    if (next === unit) return;
    unit = next;
    try { localStorage.setItem(KEY, unit); } catch (err) {}
    paint();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  if (window.MutationObserver) {
    var late = 0;
    new MutationObserver(function (l) {
      for (var i = 0; i < l.length; i++) {
        for (var j = 0; j < l[i].addedNodes.length; j++) {
          var n = l[i].addedNodes[j];
          if (n.nodeType === 1 && (n.tagName === 'TABLE' || (n.querySelector && n.querySelector('table')))) {
            clearTimeout(late); late = setTimeout(scan, 50); return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
